// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MainColor-color-ee49{color:var(--mini-text-color)}`, "",{"version":3,"sources":["webpack://./src/page/MainIcon/MainColor.module.scss"],"names":[],"mappings":"AAAA,sBACE,4BAAA","sourcesContent":[".color {\n  color: var(--mini-text-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color": `MainColor-color-ee49`
};
module.exports = ___CSS_LOADER_EXPORT___;
